import{a as E}from"./ids-chunk-UTKI53PK.js";import{a as A}from"./ids-chunk-XU2RRG76.js";import{a as y}from"./ids-chunk-BN53CJKP.js";import{a as v}from"./ids-chunk-VEO6QETS.js";import{a as g}from"./ids-chunk-U4K5B3VN.js";import{a as x,b as m}from"./ids-chunk-XE4WFW5M.js";import{a as f}from"./ids-chunk-W3LDHTW6.js";import{e as c}from"./ids-chunk-Y6KVKFJX.js";import{a as e}from"./ids-chunk-TFRXZ5TN.js";import{a as k,b as l,c as u,d as n,e as b,f as p}from"./ids-chunk-ZMMCFAAI.js";var I=`@charset "UTF-8";
/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host(.justify-center) .ids-checkbox .checkmark,
:host(.justify-center) .ids-checkbox:not([color]) input[type=checkbox] ~ .checkmark {
  top: calc(50% - 8px);
}

:host([no-margin]) .ids-checkbox {
  margin: var(--ids-space-none);
}

.ids-checkbox {
  margin-bottom: var(--ids-space-xs);
}
.ids-checkbox label {
  cursor: var(--ids-cursor-pointer);
  user-select: none;
  padding-block-start: 1px;
  padding-inline-start: var(--ids-space-md);
  margin-inline-end: 10px;
  position: relative;
  display: inline-block;
}
.ids-checkbox label.empty::before {
  content: "\xA0";
}
.ids-checkbox label.required .label-checkbox::after {
  position: absolute;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-md);
  color: var(--ids-input-required-indicator-color-text-default);
  content: "*";
  right: -10px;
  top: -3px;
}
.ids-checkbox label.no-required-indicator .label-checkbox::after, .ids-checkbox label.empty .label-checkbox::after {
  content: "";
}
.ids-checkbox.disabled label {
  cursor: var(--ids-cursor-default);
  opacity: var(--ids-checkbox-opacity-disabled);
}
.ids-checkbox.disabled label.required .label-checkbox::after {
  color: var(--ids-input-required-indicator-color-text-disabled);
}
.ids-checkbox.hitbox {
  padding-top: var(--ids-space-12);
  padding-bottom: var(--ids-space-12);
}
.ids-checkbox.hitbox label {
  padding-inline-start: 42px;
}
.ids-checkbox.hitbox label span.checkmark {
  margin-inline-start: 14px;
}
.ids-checkbox.hitbox .validation-message {
  margin-inline-start: 14px;
}
.ids-checkbox.horizontal {
  margin-inline-end: var(--ids-space-12);
  display: inline-block;
}
.ids-checkbox input[type=checkbox] {
  position: absolute;
  cursor: var(--ids-cursor-pointer);
  opacity: 0;
  height: 0;
  width: 0;
}
.ids-checkbox input[type=checkbox] ~ .checkmark {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
}
.ids-checkbox input[type=checkbox].error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-error);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark::after {
  position: absolute;
  animation: checkindeterminate 0.15s;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
}
.ids-checkbox input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-checkbox-shadow-focus);
}
.ids-checkbox input[type=checkbox]:focus.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
  box-shadow: var(--ids-checkbox-shadow-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox input[type=checkbox]:disabled ~ .label-checkbox {
  cursor: var(--ids-cursor-default);
  color: var(--ids-checkbox-color-text-disabled);
}
.ids-checkbox input[type=checkbox]:disabled.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox.no-animation input[type=checkbox]:checked ~ .checkmark::after {
  animation: none;
}
.ids-checkbox[color=green] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-green-70);
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=green] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=purple] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-purple-70);
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=purple] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=blue] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-blue-70);
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=blue] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=orange] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-orange-70);
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=orange] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=red] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-red-70);
  border-color: var(--ids-color-red-70);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=red] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-red-70);
}
.ids-checkbox .validation-message {
  margin-top: var(--ids-space-2xs);
  margin-inline-start: -1px;
}
.ids-checkbox.has-focus input[type=checkbox] ~ .checkmark {
  border-color: var(--ids-checkbox-focus-border-color);
  box-shadow: var(--ids-checkbox-focus-box-shadow);
}

:host-context(form) {
  display: flex;
}

:host([dir=rtl]) input[type=checkbox] ~ .checkmark {
  left: initial;
  right: 0;
}
:host([dir=rtl]) label.required .label-checkbox::after {
  right: initial;
  left: -13px;
}

:host(.multiselect-checkbox) input[type=checkbox]:not(:checked):not(:disabled) ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-multiselect);
}
:host(.multiselect-checkbox) .ids-checkbox label {
  padding-inline-start: var(--ids-space-sm);
}

:host(.multiselect-loaded) .ids-checkbox {
  text-indent: 0;
  margin-inline-start: var(--ids-space-xs);
}
:host(.multiselect-loaded) .ids-checkbox label {
  margin-inline-end: 0;
  padding-inline-start: 12px;
}`;var D=E(A(y(v(g(f))))),i,d,L,s=class extends D{constructor(){super();n(this,d);l(this,"labelAudible");l(this,"isFormComponent",!0);n(this,i,!1)}static get attributes(){return[...super.attributes,e.NO_ANIMATION,e.CHECKED,e.COLOR,e.DISABLED,e.HORIZONTAL,e.INDETERMINATE,e.VALUE]}connectedCallback(){super.connectedCallback(),p(this,d,L).call(this)}template(){let r=this.color?` color="${this.color}"`:"",o=c(this.labelAudible)?' audible="true"':"",t=c(this.disabled)?" disabled":"",C=c(this.horizontal)?" horizontal":"",h=c(this.checked)?" checked":"",N=c(this.noAnimation)?" no-animation":"",O=` class="ids-checkbox${t}${C}${N}"`,a="checkbox";a+=c(this.indeterminate)?" indeterminate":"",a=` class="${a}"`;let w=!(c(this.labelRequired)||this.labelRequired===null),T=!this.label.length||this.labelState==="hidden"?" empty":"";return`
      <div${O}${r} part="root">
        <label class="ids-label-text${w?" no-required-indicator":""}${T}" part="label">
          <input part="input" type="checkbox"${a}${t}${h}>
          <span class="checkmark${h}" part="checkmark"></span>
          <ids-text${o} class="label-checkbox" part="label-checkbox">${this.label}</ids-text>
        </label>
      </div>
    `}attachCheckboxChangeEvent(){this.onEvent("change",this.input,r=>{this.indeterminate=!1,b(this,i,!0),this.checked=!!this.input?.checked,this.triggerEvent(r.type,this,{detail:{elem:this,nativeEvent:r,value:this.value,checked:this.input?.checked},bubbles:!0})})}attachNativeEvents(){["focus","keydown","keypress","keyup","click","dbclick"].forEach(o=>{this.onEvent(o,this.input,t=>{t.stopPropagation(),t.stopImmediatePropagation()})})}get input(){return this.container?.querySelector('input[type="checkbox"]')}get labelEl(){return this.container?.querySelector("label")}set checked(r){let o=c(r),t=this.shadowRoot?.querySelector(".checkmark");o||this.removeAttribute(e.CHECKED),!(this.checked===o&&this.input?.checked===o)&&(this.toggleAttribute(e.CHECKED,o),t?.classList.toggle(e.CHECKED,o),this.input&&(this.input.checked=o),!u(this,i)&&this.input&&this.triggerEvent("change",this.input,{bubbles:!0}),b(this,i,!1))}get checked(){return c(this.getAttribute(e.CHECKED))}set color(r){let o=this.shadowRoot?.querySelector(".ids-checkbox");r?(this.setAttribute(e.COLOR,r.toString()),o?.setAttribute(e.COLOR,r.toString())):(this.removeAttribute(e.COLOR),o?.removeAttribute(e.COLOR))}get color(){return this.getAttribute(e.COLOR)}set disabled(r){let o=this.shadowRoot?.querySelector(".ids-checkbox"),t=c(r);t?(this.setAttribute(e.DISABLED,t.toString()),this.input?.setAttribute(e.DISABLED,t.toString()),o?.classList.add(e.DISABLED)):(this.removeAttribute(e.DISABLED),this.input?.removeAttribute(e.DISABLED),o?.classList.remove(e.DISABLED))}get disabled(){return this.getAttribute(e.DISABLED)}set horizontal(r){let o=this.shadowRoot?.querySelector(".ids-checkbox"),t=c(r);t?(this.setAttribute(e.HORIZONTAL,t.toString()),o?.classList.add(e.HORIZONTAL)):(this.removeAttribute(e.HORIZONTAL),o?.classList.remove(e.HORIZONTAL))}get horizontal(){return this.getAttribute(e.HORIZONTAL)}set indeterminate(r){let o=c(r);o?this.setAttribute(e.INDETERMINATE,o.toString()):this.removeAttribute(e.INDETERMINATE),this.input&&(o?(this.input.classList.add(e.INDETERMINATE),this.input.indeterminate=!0):(this.input.classList.remove(e.INDETERMINATE),this.input.indeterminate=!1))}get indeterminate(){return this.getAttribute(e.INDETERMINATE)}set value(r){if(!r){this.removeAttribute(e.VALUE);return}this.setAttribute(e.VALUE,r||"")}get value(){return this.checked?this.getAttribute(e.VALUE)??"on":""}set noAnimation(r){let o=c(r);o?(this.setAttribute(e.NO_ANIMATION,String(o)),this.container?.classList.add("no-animation")):(this.removeAttribute(e.NO_ANIMATION),this.container?.classList.remove("no-animation"))}get noAnimation(){return c(this.getAttribute(e.NO_ANIMATION))||!1}focus(){this.input?.focus()}};i=new WeakMap,d=new WeakSet,L=function(){this.attachCheckboxChangeEvent(),this.attachNativeEvents()},s=k([x("ids-checkbox"),m(I)],s);export{s as a};
